var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,style:(_vm.boxStyle),attrs:{"id":"chartid","chartData":_vm.chartData}})}
var staticRenderFns = []

export { render, staticRenderFns }